import { render, staticRenderFns } from "./AcademyHeaderContacts.vue?vue&type=template&id=2671c9a3&"
import script from "./AcademyHeaderContacts.vue?vue&type=script&lang=js&"
export * from "./AcademyHeaderContacts.vue?vue&type=script&lang=js&"
import style0 from "./AcademyHeaderContacts.vue?vue&type=style&index=0&id=2671c9a3&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports